import { FC } from 'react'
import { Create, SimpleForm, TextInput, required } from 'react-admin'
import { useLocation } from 'react-router-dom'
import { ToolFormFields } from '../../components'

const McpToolCreate: FC = () => {
  const location = useLocation()
  const state = location.state as { server_id?: string; serverId?: string } | undefined
  const serverId = state?.server_id || state?.serverId || ''

  return (
    <Create redirect={serverId ? `/mcp_server/${serverId}/show/tools` : 'list'}>
      {/* eslint-disable-next-line camelcase */}
      <SimpleForm
        defaultValues={{
          // eslint-disable-next-line camelcase
          server_id: serverId,
          // eslint-disable-next-line camelcase
          http_method: 'GET',
          parameters: [],
        }}
      >
        {/* readOnly, not disabled: react-hook-form strips disabled fields from
            the submitted values, which dropped server_id from the payload. */}
        <TextInput source="server_id" label="data.serverId" fullWidth validate={required()} readOnly={!!serverId} />
        <ToolFormFields />
      </SimpleForm>
    </Create>
  )
}

export default McpToolCreate
